import type { ImagingStructuredReport } from "@/core/imaging/types";

export const emptyImagingReportForm = (): ImagingStructuredReport => ({
  technique: "",
  findings: "",
  conclusion: "",
});

export function imagingReportToForm(
  report: Partial<ImagingStructuredReport> | null | undefined,
): ImagingStructuredReport {
  return {
    technique: report?.technique ?? "",
    findings: report?.findings ?? "",
    conclusion: report?.conclusion ?? "",
  };
}

interface ImagingReportFieldsProps {
  form: ImagingStructuredReport;
  canEdit: boolean;
  onChange: (patch: Partial<ImagingStructuredReport>) => void;
}

export function ImagingReportFields({ form, canEdit, onChange }: ImagingReportFieldsProps) {
  return (
    <div className="row g-3">
      <div className="col-12">
        <label className="form-label small fw-semibold mb-1" htmlFor="img-report-technique">
          Technique
        </label>
        <textarea
          id="img-report-technique"
          className="form-control form-control-sm"
          rows={2}
          placeholder="Ex. radiographie thorax face, inspiration profonde…"
          value={form.technique}
          disabled={!canEdit}
          onChange={(e) => onChange({ technique: e.target.value })}
        />
      </div>
      <div className="col-12">
        <label className="form-label small fw-semibold mb-1" htmlFor="img-report-findings">
          Constatations
        </label>
        <textarea
          id="img-report-findings"
          className="form-control form-control-sm"
          rows={5}
          placeholder="Description des images…"
          value={form.findings}
          disabled={!canEdit}
          onChange={(e) => onChange({ findings: e.target.value })}
        />
      </div>
      <div className="col-12">
        <label className="form-label small fw-semibold mb-1" htmlFor="img-report-conclusion">
          Conclusion
        </label>
        <textarea
          id="img-report-conclusion"
          className="form-control form-control-sm"
          rows={3}
          placeholder="Synthèse diagnostique…"
          value={form.conclusion}
          disabled={!canEdit}
          onChange={(e) => onChange({ conclusion: e.target.value })}
        />
      </div>
    </div>
  );
}
